<div fxLayout="column">
  <app-page-header
    [description]="'Draft and configure a lease at your own pace. Set dates, configure rates, and link spaces and approve it when you\'re ready. Spaces aren\'t reserved during planning, so you can have multiple prospective leases on the go and fall back on another if one doesn\'t go through.'"
    [section]="'Create a lease'"
    [title]="'New Planned Lease'"
  ></app-page-header>

  <div class="page-content full-screen-height-page-default fx-col">
    <app-manage-booking class="fx-align-self-start"
                        [offering]="offering"
                        [retailerId]="data.retailerId"
                        [retailerLookupOptions]="retailerLookupOptions()">
    </app-manage-booking>
  </div>
</div>
